import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function FloatingWhatsApp() {
  const messages = [
    "Request a free quotation now!",
    "Check your parts price instantly!",
    "Message us for your custom quote!",
  ];

  const [currentMessage, setCurrentMessage] = useState(0);
  const whatsappLink = process.env.REACT_APP_WHATSAPP_LINK || "#";

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessage((prev) => (prev + 1) % messages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <motion.a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed right-4 sm:right-6 z-50 flex items-center
        bg-gradient-to-r from-green-400 to-green-600 hover:from-green-500 hover:to-green-700
        text-white rounded-full shadow-lg hover:shadow-xl
        transition-all duration-300 px-3 sm:px-5 py-2 sm:py-3 max-w-[90vw]
        bottom-20 sm:bottom-20 md:bottom-20 lg:bottom-20 
        max-[1250px]:flex hidden"
    >
      {/* WhatsApp Icon */}
      <motion.img
        src="../whatsapp.png"
        alt="WhatsApp"
        className="w-6 h-6 sm:w-8 sm:h-8 md:w-9 md:h-9 flex-shrink-0"
        animate={{ scale: [1, 1.1, 1] }}
        transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
        whileHover={{ rotate: 20 }}
      />

      {/* Animated Text (hidden on very small screens) */}
      <div
        className="ml-2 sm:ml-3 flex items-center justify-center break-words hidden sm:flex"
        style={{
          minWidth: "100px",
          maxWidth: "calc(100vw - 80px)",
          lineHeight: "1.4rem",
        }}
      >
        <AnimatePresence mode="wait">
          <motion.span
            key={currentMessage}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.4 }}
            className="text-xs sm:text-sm md:text-base font-medium text-left"
          >
            {messages[currentMessage]}
          </motion.span>
        </AnimatePresence>
      </div>
    </motion.a>
  );
}
